import React from "react";
import styles from "./TravelRecommendationSection.module.css";
const TravelRecommendationSection = () => {

    return (
        <section className={styles.section}>
            <h2 className={styles.heading}>
                Tailored Travel Recommendations
            </h2>
            <p>
                AI-driven suggestions for destinations, packages, and experiences based on <br />
                traveler preferences.
            </p>
            <div className={styles.wrapper}>
                <div className={styles.featureList}>
                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Smart itinerary planning</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Personalized package recommendations</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Upsell & cross-sell opportunities</h4>
                        </div>
                    </div>
                    <div className={styles.buttons}>
                        <button className={styles.primaryBtn} >Enhance Guest Experience</button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TravelRecommendationSection;
